import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";


export const RouteSchema: RegistryItem = {
	[AgreementConditionType.Route]: {
		fields: {
			"conditions.fromLocation": {
				path: "fromLocation",
				rules: {
					required: true,
				},
			},
			"conditions.toLocation": {
				path: "toLocation",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			fromLocation: form.fromLocation?.id,
			toLocation: form.toLocation?.id,
		}),
		toForm: (condition) => ({
			fromLocation: condition.fromLocation ?? undefined,
			toLocation: condition.toLocation ?? undefined,
		}),
	},
};
